import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Erzeugungsanlage } from '../../domain/model/erzeugungsanlage';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { map } from 'rxjs/operators';
import { ErzeugungsanlageService } from '../../service/erzeugungsanlage/erzeugungsanlage.service';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { Netzbetreiber } from '../../domain/model/netzbetreiber';

@Component({
    selector: 'redispatch-erzeugungsanlage-detail',
    templateUrl: './erzeugungsanlage-detail.component.html',
    styleUrls: [
        './erzeugungsanlage-detail.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlageDetailComponent {

    public createNewMode = false;
    public dokumentenId: string;

    public netzbetreiber$: Observable<Netzbetreiber>;
    public erzeugungsanlage$: Observable<Erzeugungsanlage>;
    public readonly$: Observable<boolean>;

    private erzeugungsanlageService = inject(ErzeugungsanlageService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private netzbetreiberService = inject(NetzbetreiberService);
    private activeRoute = inject(ActivatedRoute);
    private authService = inject(AuthenticationService);

    constructor() {
        this.dokumentenId = this.activeRoute.snapshot.queryParams['erzeugungsanlage'];
        this.createNewMode = this.activeRoute.snapshot.queryParams['createnew'] === 'true';

        this.readonly$ = this.authService.user$.pipe(map(u => !!u && u.netzbetreiberType === 'WESTNETZ'));
        this.netzbetreiber$ = this.netzbetreiberService.getNetzbetreiber(this.teilgebietSelectionService.getSelectedStadtwerkeId());

        if (!this.createNewMode) {
            this.erzeugungsanlage$ = this.erzeugungsanlageService.getErzeugungsanlage(this.dokumentenId);
        }
    }
}
